export default "__VITE_ASSET__DXanV90G__"